var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"outlined":"","hide-details":"","dense":"","type":"number","min":"0","max":"100","suffix":"%","value":_vm.value},on:{"input":(v) => _vm.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }